import React from 'react';
import FigmaBadge from '../../../../Elements/FigmaBadge';
import {
  getInvoiceAutomationStatusBadge,
  getInvoicedWithNote,
} from '../../../../Helpers/invoiceAutomationStatusHelper';

// The status chip of a project's automatic invoicing; renders nothing when no setup invoices the project's jobs. For a
// project on another setup's invoice (invoicedWithProjectId) it is that setup's status, with a short note naming the
// setup's project.
export default function InvoiceAutomationStatusChip({
  isActive = null,
  runSchedule = null,
  invoicedWithProjectId = null,
  invoicedWithProjectName = null,
}) {
  const badge = getInvoiceAutomationStatusBadge(isActive, runSchedule);
  if (badge === null) {
    return null;
  }

  const statusBadge = (
    <FigmaBadge
      variant={badge.variant}
      label={badge.label}
    />
  );
  if (invoicedWithProjectId == null) {
    return statusBadge;
  }

  const invoicedWithNote = getInvoicedWithNote(invoicedWithProjectId, invoicedWithProjectName);
  return (
    <span
      className='iauto-status-with'
      title={invoicedWithNote.tooltip}
    >
      {statusBadge}
      <span className='iauto-status-with-note'>{invoicedWithNote.text}</span>
    </span>
  );
}
